import React, { ReactNode } from "react"
import Loader from "../Loader"
export function LoadingButtonBody({ label, loading = false }: { label: string | ReactNode, loading?: boolean }): JSX.Element {
  return <>
    <div
      className={`flex items-center space-x-2 transition-opacity duration-300 ${loading ? "opacity-100" : "opacity-0"
        }`}
    >
      {loading && <Loader className="mr-2" />}
    </div>
    <span className={`transition-opacity duration-300 ${loading ? "opacity-50" : "opacity-100"}`}>
      {label}
    </span>
  </>
}